const Natures = {
  RootbeerEnabled: "rootbeer-enabled",
  ResultsDisabled: "results-disabled",
  ComplianceFirst: "compliance-first",
  ExpandableCompliance: "expandable-compliance",
  QuestionReporting: "question-reporting-enabled",
  ShowPollByCS: "show-poll-by-cs",
  ContentRecommendationEngineEnabled: "cre",
  HorizontalOptions: "horizontal-options", //CS-333 && CS-713
  GAMTargeting: "gam-targeting", //CS-1131
  BackButtonEnabled: "back-button-enabled", //CS-1146
  BackgroundImgEnabled: "background-img-enabled", //CS-2193
  BulkResponseDeleteEnabled: "bulk-response-delete", //CS-5386

  //TEST NATURES BELOW
  ContentRecommendationEngineEndEnabled: "testContentRecEnd", //COL-60
  TestQuestionDynamicNext: "testQuestionDynamicNext", //CS-309
  TestNoAutoAdvance: "testNoAutoAdvance", //CS-309
  TestShareModal: "testShareModal", //CS-714
  TestAgePicker: "testAgePicker", //CS-5440
  TestAgeNumpad: "testAgeNumpad", //CS-5440
};

export default Natures;
